import React, { useEffect, useState } from "react";
import "../styles/Research.css";
import EarnMorePipline from "../assets/EarnMore.png";
import earnmore_app_returns1 from "../assets/earnmore_app_returns1.png";
import earnmore_app_returns2 from "../assets/earnmore_app_returns2.png";
import earnmore_app_returns3 from "../assets/earnmore_app_returns3.png";
import Button from "../components/Button";
import DatePicker from "react-datepicker";
import { ToastContainer, toast } from "react-toastify";
import { PMRequest, trainRequest } from "../services/trademasterService";
import { Buffer } from "buffer";
import 'bootstrap/dist/css/bootstrap.min.css';

// const TsxPage = () => {
//
//     const handleButtonClick = () => {
//         window.location.href = '/professional_kline_chart.html';
//     };
//
//     return (
//         <div>
//             <h1>This is a TSX page</h1>
//             <button onClick={handleButtonClick}>Go to HTML Page</button>
//         </div>
//     );
// };
//
// export {TsxPage};

export default function EarnMore() {
    const [startDate, setStartDate] = useState(new Date("2023-01-01"));
    const [endDate, setEndDate] = useState(new Date());
    const [showDate, setshowDate] = useState<number>(30);
    const minDate = new Date("2000-01-01");
    const maxDate = new Date();
    const mydata = [1, 2, 3, 4, 5]

    const [BtnDisabled, setBtnDisabled] = useState(false);

    const [figure1Base64String, setFigure1Base64String] = useState("");
    const [figure1Url, setFigure1Url] = useState("");
    const [figure2Base64String, setFigure2Base64String] = useState("");
    const [figure2Url, setFigure2Url] = useState("");
    const [optionSelected, setOptionSelected] = useState({
        start_date: startDate,
        end_date: endDate,
        show_dates: showDate,
        reinfer: ""
    });

    interface StockItem {
        stock: string;
        weight: string;
        image: string;
        url: string
    }

    interface Props {
        Output: StockItem[];
    }

    const StockGrid: React.FC<Props> = ({Output}) => {
        return (
            <div className="row">
                {Output.map((item, index) => (
                    <div className="col-6 col-md-4 my-2" key={index}>
                        <div className="card">
                            <a href={item.url} target="_blank" rel="noopener noreferrer">
                                <img
                                    src={`data:image/jpeg;base64,${item.image}`}
                                    className="card-img-top"
                                    alt="Stock Image"
                                    style={{backgroundColor: '#D3D3D3'}}
                                />
                            </a>
                            <div className="card-body">
                                <h5 className="card-title">{item.stock}</h5>
                                <p className="card-text">Weight: {item.weight}</p>
                            </div>
                        </div>
                    </div>
                ))}

                {/* {mydata.map((item, index) => (
                    <div className="col-6 col-md-4 my-2" key={index}>
                        <div className="card">
                            <a href={item.url} target="_blank" rel="noopener noreferrer">
                                <img
                                    src='https://img2.baidu.com/it/u=3227619927,365499885&fm=253&fmt=auto&app=120&f=JPEG?w=938&h=500'
                                    className="card-img-top"
                                    alt="Stock Image"
                                    style={{ backgroundColor: '#D3D3D3' }}
                                />
                            </a>
                            <div className="card-body">
                                <h5 className="card-title">123</h5>
                                <p className="card-text">Weight:234</p>
                            </div>
                        </div>
                    </div>
                ))} */}
            </div>
        );
    };

    const [requestOutput, setRequestOutput] = useState<StockItem[]>([]);

    const CollapsibleBox = () => {
        const [isOpen, setIsOpen] = useState(false);

        return (
            <div className="collapsible-box">
                <button className="collapsible-button" onClick={() => setIsOpen(!isOpen)}>
                    {isOpen ? "Hide Explanation of Parameters and Results" : "Show Explanation of Parameters and Results"}
                </button>

                {isOpen && (
                    <div className="collapsible-content">
                        <p className="instructions-container">
                            <li>
                                <strong>EarnMore Cumulative Return</strong>: Data vs. Cumulative Return curve.
                            </li>
                            <li>
                                <strong>Start Date</strong>: The initiation date for the trading test.
                            </li>
                            <li>
                                <strong>End Date</strong>: The end date of trading test, the default value is today.
                            </li>
                            <li>
                                <strong>Show Dates</strong>: The number of recent days shown on the following line
                                graph.
                            </li>
                            <li>
                                <strong>Top-k Results</strong>: Today's recommended top-5 stocks and corresponding
                                portfolios.
                            </li>
                        </p>
                    </div>
                )}
            </div>
        );
    };

    // 跳转到 professional_kline_chart.html 页面
    const handleButtonClick = () => {
        window.location.href = '/professional_kline_chart.html';
    };

    const PMOnClick = () => {
        console.log("Performing some action...");
        setBtnDisabled(false);
    };


    // const PMOnClick = () => {
    //     console.log(optionSelected)
    //     console.log('PM')
    //
    //     optionSelected.reinfer = "true";
    //
    //     notifyToast(
    //         "Request submitted! Please be patient...",
    //         "info"
    //     );
    //     let promise = PMRequest(optionSelected);
    //     promise
    //         .then((res) => {
    //             console.log("res", res)
    //             // let newStr = res.data.topk;
    //             // setRequestOutput(newStr);
    //             notifyToast("Response Received! Output Updated", "success");
    //             setFigure1Base64String(res.djia)
    //             setFigure2Base64String(res.returns)
    //             setRequestOutput(JSON.parse(res.topk))
    //             setBtnDisabled(false);
    //         })
    //         .catch((error) => {
    //             console.log("error", error);
    //             notifyToast(error, "error");
    //         });
    // };

    // const PMOnInit = () => {
    //     console.log(optionSelected)
    //     console.log('PM')
    //
    //     optionSelected.reinfer = "";
    //
    //     notifyToast(
    //         "Request submitted! Please be patient...",
    //         "info"
    //     );
    //     let promise = PMRequest(optionSelected);
    //     promise
    //         .then((res) => {
    //             console.log("res", res)
    //             // let newStr = res.data.topk;
    //             // setRequestOutput(newStr);
    //             notifyToast("Response Received! Output Updated", "success");
    //             setFigure1Base64String(res.djia)
    //             setFigure2Base64String(res.returns)
    //             setRequestOutput(JSON.parse(res.topk))
    //             setBtnDisabled(false);
    //         })
    //         .catch((error) => {
    //             console.log("error", error);
    //             notifyToast(error, "error");
    //         });
    // };

    // useEffect(() => {
    //     PMOnInit();
    // });

    useEffect(() => {
        if (figure1Base64String) {
            //convert base64 to utf8array, then to Blob
            const byteString = Buffer.from(figure1Base64String, "base64");
            const blob = new Blob([byteString.buffer]);
            const url = URL.createObjectURL(blob);

            // Set the URL as the imageUrl state variable
            setFigure1Url(url);
        }
    }, [figure1Base64String]);

    useEffect(() => {
        if (figure2Base64String) {
            //convert base64 to utf8array, then to Blob
            const byteString = Buffer.from(figure2Base64String, "base64");
            const blob = new Blob([byteString.buffer]);
            const url = URL.createObjectURL(blob);

            // Set the URL as the imageUrl state variable
            setFigure2Url(url);
        }
    }, [figure2Base64String]);

    const notifyToast = (text, type) => {
        if (type == "success") {
            toast.success(text);
        } else if (type == "error") {
            toast.error(text);
        } else if (type == "info") {
            toast.info(text);
        }
    };

    return (

        <div>
            <div className="aa">
                <div className="topa">
                    <div className="form-floating">
                        <div style={{fontSize: "50px", textAlign: "left", fontWeight: 700}}>
                            Portfolio Return Curve with Daily Real-time Updates
                        </div>
                        {/*<div className="row my-2">*/}
                        {/*    <div className="card custom-card">*/}

                        {/*        {figure2Url !== "" ? (*/}
                        {/*            <img*/}
                        {/*                src={figure2Url}*/}
                        {/*                alt="result_plot2"*/}
                        {/*                className="img-fluid zoomed"*/}
                        {/*            />*/}
                        {/*        ) : (*/}
                        {/*            <div className="placeholder-content"></div>*/}
                        {/*        )}*/}

                        {/*    </div>*/}
                        {/*</div>*/}
                    </div>

                    {/* 按钮，点击后跳转到 /professional_kline_chart.html */}
                    <div className="row mt-4">
                        <div className="col-4 offset-4 text-center">
                            <Button
                                type="primary"
                                onClick={handleButtonClick}  // 点击跳转到 /professional_kline_chart.html
                                disabled={BtnDisabled}
                            >
                                Go to Trading Records
                            </Button>
                        </div>
                    </div>

                    <br/><br/>

                    <h3 style={{fontSize: "25px", textAlign: "center", fontWeight: 500}}>

                        <p style={{fontSize: "20px", color: "#fff", fontWeight: 300}}>
                            Train: 2007-09-26~2023-12-31
                            <br/>
                            <br/>
                            Test: 2023-04-15~latest
                        </p>
                    </h3>

                    <h5 style={{fontSize: "30px", textAlign: "justify", fontWeight: 300}}>
                        <span style={{fontSize: "30px", textAlign: "justify", fontWeight: 700}}>Portfolio Management (PM)</span>
                        is a fundamental financial trading task, which explores the optimal periodical reallocation of
                        capitals
                        into different stocks to pursue long-term profits.
                    </h5>
                </div>
            </div>

            <div className="topa2">
                <div className="form-floating">
                    <div style={{fontSize: "50px", textAlign: "center", fontWeight: 700}}>
                        Our Methods
                    </div>
                </div>
                <div style={{fontSize: "22px", textAlign: "justify", fontWeight: 300}}>
                    <span style={{fontSize: "30px", textAlign: "justify", fontWeight: 700}}>Datasets: </span>
                    In our experiments, we utilized daily K-line data from Yahoo Finance covering the period from
                    September 26, 2007, to June 26, 2022, for 2 US stock markets: the S&P 500 (SP500) and the Dow Jones
                    Industrial Average (DJ30).
                </div>

                <div style={{fontSize: "22px", textAlign: "justify", fontWeight: 300, marginTop: '20PX'}}>
                    <span style={{fontSize: "30px", textAlign: "justify", fontWeight: 700}}>EarnMore: </span>
                    We propose EarnMore, a rEinforcement leARNing framework with Maskable stOck REpresentation to cater
                    to investor preferences and to adapt to investor decision-making.
                    Please refer to the
                    <a
                        href="https://arxiv.org/abs/2311.10801"
                        style={{textDecoration: "underline"}}
                        target="_blank">
                        EarnMore paper </a>for more information.
                    We have open-sourced both the training and testing code. You can find the code repositories at <a
                    href="https://github.com/DVampire/EarnMore"
                    style={{textDecoration: "underline"}}
                    target="_blank">
                    https://github.com/DVampire/EarnMore </a>.
                </div>
                <img src={EarnMorePipline} alt="EarnMore pipeline" className="img-fluid" style={{marginTop: '20PX'}}/>


            </div>


            <div className="aa">
                <div className="topa">
                    <div className="evt1" style={{marginTop: '20px', textAlign: 'center'}}>
                        Performance Analysis of Historical Data
                    </div>
                    <div style={{fontSize: '22px', lineHeight: '40px', marginTop: '20px'}}>
                        We conducted performance testing of EarnMore over 3 date groups, with the date range for both
                        the training and testing sets depicted in the figures.
                        The x-axis represents dates, indicating daily portfolio adjustments, while the y-axis depicts
                        cumulative returns.
                    </div>
                    <div style={{marginTop: "40px"}}>
                        <img src={earnmore_app_returns1} alt="earnmore_app_returns1" className="img-fluid"/>
                        <h3 style={{fontSize: "25px", textAlign: "center", fontWeight: 500}}>
                            <p style={{color: "#fff", marginTop: "20px"}}>
                                Fig1. Performance of Date Group 1 on SP500 and DJ30
                            </p>
                            <p style={{fontSize: "20px", color: "#fff", fontWeight: 300}}>
                                <div>Train: 2007-09-26~2018-01-25</div>
                                <div style={{marginTop: '10px'}}>Test: 2018-01-26~2019-07-22</div>


                            </p>
                        </h3>
                    </div>


                    <div style={{marginTop: "30px"}}>
                        <img src={earnmore_app_returns2} alt="earnmore_app_returns2" className="img-fluid"/>
                        <h3 style={{fontSize: "25px", textAlign: "center", fontWeight: 500}}>
                            <p style={{color: "#fff", marginTop: "20px"}}>
                                Fig2. Performance of Date Group 2 on SP500 and DJ30
                            </p>
                            <p style={{fontSize: "20px", color: "#fff", fontWeight: 300}}>
                                <div>Train: 2007-09-26~2019-07-22</div>
                                <div style={{marginTop: '10px'}}>Test: 2019-07-23~2021-01-08</div>

                            </p>
                        </h3>
                    </div>

                    <br/>

                    <div>
                        <img src={earnmore_app_returns3} alt="earnmore_app_returns3" className="img-fluid"/>
                        <h3 style={{fontSize: "25px", textAlign: "center", fontWeight: 500}}>
                            <p style={{color: "#fff", marginTop: "20px"}}>
                                Fig3. Performance of Date Group 3 on SP500 and DJ30
                            </p>
                            <p style={{fontSize: "20px", color: "#fff", fontWeight: 300}}>
                                <div>Train: 2007-09-26~2021-01-07</div>
                                <div style={{marginTop: '10px'}}> Test: 2021-01-08~2022-06-26</div>


                            </p>
                        </h3>
                    </div>

                </div>
            </div>
            <div>


                <div className="topa2">
                    <h3 style={{fontSize: "42px", textAlign: "center", fontWeight: 700}}>
                        Try EarnMore
                    </h3>
                    <div className="form-floating" style={{marginTop: '30px'}}>
                        <p className="instructions-container" style={{fontSize: '20px'}}>
                            <li>
                                <strong>EarnMore Cumulative Return</strong>: Data vs. Cumulative Return curve.
                            </li>
                            <li>
                                <strong>Start Date</strong>: The initiation date for the trading test.
                            </li>
                            <li>
                                <strong>End Date</strong>: The end date of trading test, the default value is today.
                            </li>
                            <li>
                                <strong>Show Dates</strong>: The number of recent days shown on the following line
                                graph.
                            </li>
                            <li>
                                <strong>Top-k Results</strong>: Today's recommended top-5 stocks and corresponding
                                portfolios.
                            </li>
                        </p>
                        <h2 style={{marginTop: '30px'}}>{'\u2460'} Set Parameters</h2>
                    </div>

                    <div className="row">
                        <div className="col my-2">
                            <div className="row">
                                <div className="col">
                                    <div>Start Date</div>
                                    <DatePicker
                                        className="datepicker"
                                        id="testDatePicker"
                                        dateFormat="yyyy-MM-dd"
                                        placeholderText="YYYY-MM-DD"
                                        selected={startDate}
                                        minDate={minDate}
                                        maxDate={maxDate}
                                        onChange={(date) => {
                                            setStartDate(date);
                                            // let temp = optionSelected;
                                            // temp.start_date = getDateStrFromDate(date);
                                            // console.log("temp", temp);
                                            // setOptionSelected(temp);
                                        }}
                                    />
                                </div>
                                <div className="col">
                                    <div>End Date</div>
                                    <DatePicker
                                        className="datepicker"
                                        id="testDatePicker"
                                        dateFormat="yyyy-MM-dd"
                                        placeholderText="YYYY-MM-DD"
                                        selected={endDate}
                                        minDate={minDate}
                                        maxDate={maxDate}
                                        onChange={(date) => {
                                            setEndDate(date);
                                            // let temp = optionSelected;
                                            // temp.end_date = getDateStrFromDate(date);
                                            // console.log("temp", temp);
                                            // setOptionSelected(temp);
                                        }}
                                    />
                                </div>
                                <div className=" col tooltip-container">
                                    <div>Show Dates</div>
                                    <input
                                        type="number"
                                        id="showdates"
                                        style={{marginTop: '10px'}}
                                        className="form-control"
                                        min="0"
                                        max='999999'
                                        onChange={(e) => setshowDate(Number(e.target.value))}
                                        value={showDate}
                                    />

                                </div>
                            </div>
                        </div>
                    </div>

                </div>


                <div className="row" style={{marginTop: '20px'}}>
                    <div className="offset-4 col-4 button-col">
                        <Button
                            disabled={BtnDisabled}
                            type="primary"
                            onClick={() => {

                                setRequestOutput("");
                                setFigure1Base64String("");
                                setFigure1Url("");
                                setFigure2Base64String("");
                                setFigure2Url("");
                                setBtnDisabled(true);
                                // setTrainBtnDisabledTimer();
                                // console.log("optionSelected", optionSelected);
                                // PMOnClick();
                            }}
                        >
                            {'\u2461'} Run EarnMore
                        </Button>


                    </div>

                </div>


            </div>

            <ToastContainer/>


            <div className="topa2">
                <div className="row my-2">
                    <h3>{'\u2462'} Top-k Results </h3>
                </div>

                <StockGrid Output={requestOutput}/>
            </div>


        </div>


    );
}